module.exports = __webpack_public_path__ + "static/media/stripe-logo.66b87774.svg";